"use client";
import { useState } from "react";

import type { MobileNavigationProps } from "@/services/navigation/types";

import { MobileNavbar } from "./mobile-navbar";
import { MobileNavbarDropdownItem } from "./mobile-navbar-dropdown-item";
import { MobileNavbarItem } from "./mobile-navbar-item";

export function CmsMobileNavbar({ data }: { data: MobileNavigationProps }) {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <MobileNavbar className="h-[var(--mobile-navbar-height)] md:hidden">
      {data.items.map((el) => (
        <MobileNavbarItem key={el.label} icon={el.icon} href={el.href}>
          {el.label}
        </MobileNavbarItem>
      ))}
      <li className="flex w-full flex-1 cursor-pointer flex-col items-center justify-center gap-0.5">
        <MobileNavbarDropdownItem data={data.content} open={isOpen} onOpenChange={setIsOpen} />
      </li>
    </MobileNavbar>
  );
}
